import type { SubPractices } from "../config.types";

import {
  immigrationBookLssScreens,
  immigrationEligibleForLssScreens,
  intakeConfirmationScreens,
} from "./common-immigration";

export const immigrationFianceVisa: SubPractices = {
  firstScreen: "service-type",
  screens: {
    "service-type": {
      next: async ({ answers, funnelExperimentContext }) => {
        const { fianceRelationshipStatus } = answers;

        if (fianceRelationshipStatus === "Something else") {
          return "out-of-scope";
        }

        if (funnelExperimentContext.showAdditionalFianceSteps()) {
          return "partner-interaction-us-status";
        }

        return "partner-interaction";
      },
    },
    "partner-interaction-us-status": {
      next: async ({ answers }) => {
        if (answers.partnerInteractionUsStatus === "Yes") {
          return "partner-interaction";
        }
        return "out-of-scope";
      },
    },
    "applicant-type": {
      next: async () => "case-urgency",
    },
    "partner-interaction": {
      next: async () => "deportation-or-removal",
    },
    "case-urgency": {
      next: async () => "more-info",
    },
    "sponsor-info": {
      next: async () => "currently-represented",
    },

    ...immigrationEligibleForLssScreens,

    "funding-source": {
      next: async () => "beneficiary-region",
    },
    "beneficiary-region": {
      next: async () => "more-info",
    },

    ...intakeConfirmationScreens,
    ...immigrationBookLssScreens,

    "out-of-scope": {
      next: async () => undefined,
    },
  },
};
